import React, { ReactElement, useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Toast } from 'src/components/Toast';
import {
  ToastMessageContext,
  ToastMessage,
} from 'src/context/toastMessageContext';
import { SpaceBetween } from '@cloudscape-design/components';

export const ToastPortal = (): ReactElement => {
  const mountingElement = document.createElement('div');
  const { toasts } = useContext(ToastMessageContext);
  const [loaded, setLoaded] = React.useState(false);
  mountingElement.id = 'toast-portal-mount-point';

  useEffect(() => {
    document.body.prepend(mountingElement);
    setLoaded(true);

    return () => {
      mountingElement.parentElement?.removeChild(mountingElement);
    };
  }, []);

  if (loaded) {
    const injectionSite = document.getElementById('toast-portal-mount-point');

    return injectionSite ? (
      createPortal(
        <div className="toast-portal">
          <SpaceBetween size="m">
            {toasts.map((toast: ToastMessage, index) => {
              return (
                <Toast
                  key={index}
                  header={toast.header}
                  description={toast.description}
                  type={toast.type}
                  dismissTime={toast.dismissTime}
                  onDismiss={toast.onDismiss}
                />
              );
            })}
          </SpaceBetween>
        </div>,
        injectionSite,
      )
    ) : (
      <></>
    );
  }
  return <></>;
};
